import FamilyType from './FamilyType'
import EquipmentGraphics from './EquipmentGraphics'
export class RemovalInfo {
    RequestID: number;
    EquipmentAssetNumber: string;
    SerialNumber: string;
    FamilyTypeID?: number;
    FamilyType?: FamilyType;
    Model: string;
    EquipmentGraphicsID?: number;
    EquipmentGraphics?: EquipmentGraphics;
    PhoneNumberExtenLocation: string;
    Location: string;
}

export default RemovalInfo;